var _style, _g, _g2, _rect, _defs, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrEpItLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{clip-path:url(#SVGID_00000088835764752098421120000007427505511712043420_);}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#00374D;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000181047061050028694230000005364480976143767439_);}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000094608025286064779950000013566424456735014046_);}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000003821777607027207010000010372184564705882281_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page_background",
    transform: "scale(1 -1)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000127760521525082968140000001779553919864245176_",
    transform: "scale(1 -1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000026871650322899182810000008262234180146864768_",
    transform: "scale(1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ClipView"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    className: "st0",
    width: 72,
    height: -72
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: -72,
    width: 72,
    height: 72
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000037651668437990901320000016676126815973553598_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000037651668437990901320000016676126815973553598_)"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    markerEnd: "none",
    markerStart: "none",
    className: "st2",
    d: "M24.3-28.6c0,2.8,2.3,5.1,5.1,5.1c2.8,0,5.1-2.3,5.1-5.1 c0-2.8-2.3-5.1-5.1-5.1C26.6-33.7,24.3-31.4,24.3-28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "none",
    markerStart: "none",
    className: "st2",
    d: "M14.3-28.6c0,8.3,6.7,15,15,15c5.7,0,10.7-3.2,13.2-7.9 c-0.8-0.6-1.5-1.4-2.1-2.2c-1.9,4.3-6.2,7.3-11.1,7.3c-6.7,0-12.2-5.5-12.2-12.2c0-6.7,5.5-12.2,12.2-12.2 c3.8,0,7.1,1.7,9.4,4.4c0.3-1,0.6-2,1.1-3c-2.7-2.6-6.4-4.2-10.4-4.2C21.1-43.6,14.3-36.9,14.3-28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "none",
    markerStart: "none",
    className: "st2",
    d: "M3-28.6C3-14.1,14.8-2.2,29.4-2.2c11.7,0,21.7-7.7,25.1-18.3 c-1.5,0.9-3.3,1.4-5.3,1.4c-0.3,0-0.5,0-0.8,0c-3.5,7-10.7,11.8-19,11.8c-11.7,0-21.3-9.5-21.3-21.3c0-11.7,9.5-21.3,21.3-21.3 c3.3,0,6.4,0.7,9.1,2.1c-2.2-2.4-4.6-4.8-7.2-7.1C30.6-55,30-55,29.4-55C14.8-55,3-43.2,3-28.6z M50.6-28.6c0,0.7,0,1.4-0.1,2 c0.5-0.1,0.9-0.2,1.3-0.4l0.8-0.5l-1.8-3.3l-0.5-0.9l0,0.1C50.6-30.7,50.6-29.6,50.6-28.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114792102332590893120000017862787241902752695_",
    gradientUnits: "userSpaceOnUse",
    x1: -468.0009,
    y1: 582.2544,
    x2: -423.8279,
    y2: 582.2544,
    gradientTransform: "matrix(-0.8317 -0.5553 0.8489 -0.6356 -832.3085 65.2409)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#700A0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4227,
    style: {
      stopColor: "#DF1413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E65044"
    }
  })), /*#__PURE__*/React.createElement("path", {
    markerEnd: "none",
    markerStart: "none",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000114792102332590893120000017862787241902752695_)"
    },
    d: " M37.5-69.7l-9.1,9.7c12.5,10,21.2,21.3,27.3,33.8C62.3-29.7,55.7-44.6,37.5-69.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125595365409258676410000000984219290409770401_",
    gradientUnits: "userSpaceOnUse",
    x1: 301.466,
    y1: -910.298,
    x2: 355.768,
    y2: -910.298,
    gradientTransform: "matrix(0.7414 -0.671 0.9253 0.5113 652.6028 638.7864)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#700A0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3141,
    style: {
      stopColor: "#DF1413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5191,
    style: {
      stopColor: "#F1A193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#DF1413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E65044"
    }
  })), /*#__PURE__*/React.createElement("path", {
    markerEnd: "none",
    markerStart: "none",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000125595365409258676410000000984219290409770401_)"
    },
    d: " M61.4-68.3l9.1,9.7C53.8-44.3,47.2-36.3,45.2-24.9C33.9-31.3,43.1-43.1,61.4-68.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097471918705863739520000008271199628767033228_",
    gradientUnits: "userSpaceOnUse",
    x1: -165.6138,
    y1: -1517.2644,
    x2: -148.7308,
    y2: -1517.2644,
    gradientTransform: "matrix(0.9967 -8.073161e-02 0.16 0.9903 447.005 1462.9835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C71211"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5756,
    style: {
      stopColor: "#F1A193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C71211"
    }
  })), /*#__PURE__*/React.createElement("path", {
    markerEnd: "none",
    markerStart: "none",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000097471918705863739520000008271199628767033228_)"
    },
    d: " M49.2-24.4c-4.7,0-8.5-3.4-9-7.8c0,0.3,0,0.6,0,1c0,5.5,4,9.9,9,9.9c5,0,9-4.5,9-9.9c0-0.3,0-0.6,0-1 C57.7-27.8,53.9-24.4,49.2-24.4z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrEpItLogo);
export default __webpack_public_path__ + "static/media/PrEP-itLogo.165d3e30efd6ab87c70c904fc45be62d.svg";
export { ForwardRef as ReactComponent };